import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { breakPoints } from '~/src/constants/breakpoints';
import { BACKGROUND_COLOR_BLACK } from '~/src/features/movix-new/constants';

import { CardWrapper, Description, Image, Title } from '~/src/features/movix-new/Card/styled';
import { Cards, Container } from '~/src/features/movix-new/styled';

const mixinGradient = () => `
    content: '';
    position: absolute;
    width: 1689px;
    background: radial-gradient(48.12% 30.66% at 50% 54.13%, rgba(15, 80, 240, .59) 0%, rgba(15, 80, 240, 0) 100%);
    mix-blend-mode: normal;
    opacity: 0.35;
    z-index: 1;
`;

export const MovixBenefits = styled.div`
    width: 100%;
    background-color: ${BACKGROUND_COLOR_BLACK};
    margin-top: -2px;
    position: relative;

    @media (min-width: 768px) {
        &:after {
            ${mixinGradient()}
            height: 1845px;
            top: -15%;
            left: calc(100% - 760px);
        }

        &:before {
            ${mixinGradient()}
            height: 1245px;
            right: calc(100% - 700px);
        }
    }

    @media (max-width: ${breakPoints.mobile}) {
        &:after {
            ${mixinGradient()}
            width: 2662px;
            height: 945px;
            left: calc(100% - 1600px);
            top: -430px;
            opacity: 0.25;
            z-index: auto;
        };

        &:before {
            ${mixinGradient()}
            top: 12%;
            height: 1245px;
            right: calc(100% - 600px);
        }
    }
`;

export const UltraHDContainer = styled.div`
    width: 100%;
    height: 144px;
    background-image: url(${require('~/static/images/movix-new/ultra-hd-web.png')});
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 24px;

    @media (max-width: ${breakPoints.desktop}) {
        background-position: bottom;
    }

    @media (max-width: ${breakPoints.sDesktop}) {
        background-position: 70% 100%;
    }

    @media (max-width: ${breakPoints.tablet}) {
        height: 164px;
        background-position: 80% 50%;
    }
`;

export const TextContainer = styled.div`
    width: 60%;
    padding: 28px 0 14px 50px;
    flex-direction: column;
    row-gap: 10px;

    @media (max-width: ${breakPoints.desktop}) {
        padding-left: 31px;
    }
`;

export const TitileHd = styled.div`
    ${FONTS.H3};
    color: ${COLORS.TextWhite};

    @media (max-width: ${breakPoints.tablet}) {
        ${FONTS.H4};
    }
`;

export const SubtextHd = styled.div`
    ${FONTS.S};
    color: ${COLORS.TextWhite};

    @media (max-width: ${breakPoints.sDesktop}) {
        ${FONTS.XS};
    }

    @media (max-width: ${breakPoints.tablet}) {
        max-width: 322px;

        br {
            display: none;
        }
    }
`;

export const BenefitsTitle = styled.div`
    ${FONTS.H2};
    color: ${COLORS.TextWhite};
    margin-bottom: 14px;
    margin-top: 25px;

    @media (max-width: ${breakPoints.desktop}) {
        margin-top: 5px;
    }

    @media (max-width: ${breakPoints.sDesktop}) {
        margin-top: 10px;
        ${FONTS.H3};
    }

    @media (max-width: ${breakPoints.tablet}) {
        margin-top: 15px;
        margin-bottom: 17px;
    }

    @media (max-width: ${breakPoints.mobile}) {
        ${FONTS.H4};
        text-align: center;
        margin-bottom: 25px;
        margin-top: 45px;
    }
`;

export const ContainerBenefits = styled(Container)`
    row-gap: 16px;
    z-index: 2;

    @media (max-width: ${breakPoints.tablet}) {
        justify-content: center;
    }

    ${Image} {
        border-radius: 16px;
        margin-bottom: 0;

        &:before {
            @media (max-width: ${breakPoints.desktop}) {
                content: none;
            }
        }
    }

    ${Title} {
        white-space: pre;
        margin-top: 35px;
        ${FONTS.H3};

        @media (max-width: ${breakPoints.desktop}) {
            margin-top: 33px;
        }

        @media (max-width: ${breakPoints.tablet}) {
            margin-top: 20px;
            margin-left: 16px;
            ${FONTS.H4};
        }

        @media (max-width: ${breakPoints.mobile}) {
            white-space: normal;
        }
    }

    ${Description} {
        ${FONTS.S};
        width: auto;

        @media (max-width: ${breakPoints.sDesktop}) {
            ${FONTS.XS};

            br {
                display: none;
            }
        }

        @media (max-width: ${breakPoints.tablet}) {
            margin-left: 16px;
        }
    }

    ${CardWrapper} {
        padding: 8px 8px 40px;
        max-width: 100%;
    }

    ${Cards}:nth-child(2) {

        ${CardWrapper}:nth-child(1) {

            ${Image} {
                background-image: url('${require('~/static/images/movix-new/gamer.png')}');

                @media (max-width: ${breakPoints.tablet}) {
                    height: 168px;
                }

                @media (max-width: ${breakPoints.mobile}) {
                    background-image: url('${require('~/static/images/movix-new/gamer-mobile.png')}');
                }
            }
        }
    }

    ${Cards}:nth-child(4) {

        ${Image} {
            height: 168px;
            background-position: 100% 22%;
        }
    }

    ${CardWrapper}:nth-child(1) {
        flex-basis: 66%;

        @media (max-width: ${breakPoints.tablet}) {
            flex-basis: 100%;
        }
    }

    ${CardWrapper}:nth-child(2) {
        flex-basis: 32%;
        padding-bottom: 30px;

        @media (max-width: ${breakPoints.desktop}) {
            flex-basis: 34%;
        }

        ${Image} {
            background-size: contain;

            @media (max-width: ${breakPoints.sDesktop}) {
                background-position: top;
            }
        }

        @media (max-width: ${breakPoints.tablet}) {
            display: none;
        }
    }
`;

export const CardsBenefits = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    width: 100%;
    column-gap: 24px;

    @media (max-width: ${breakPoints.desktop}) {
        column-gap: 22px;
    }

    @media (max-width: ${breakPoints.sDesktop}) {
        column-gap: 16px;
    }

    @media (max-width: ${breakPoints.tablet}) {
        flex-wrap: wrap;
        gap: 12px;
    }

    @media (max-width: ${breakPoints.mobile}) {
        flex-direction: column;
        row-gap: 24px;
    }
`;
